<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="list-result">
        <div class="object-push-left">
          <div class="media-type">
            <i
              :class="['fa', 'fa-4x', thumbnailObject.icon]"
              :title="
                joinArray(
                  r._source.type.map((o) => o.value),
                  '; '
                )
              "
            ></i>
            <label class="text-overflow-ellipsis">{{ thumbnailObject.label }}</label>
          </div>
          <div class="object-details">
            <span class="object-heading"
              ><a :href="'/object/' + r._source.rap_identifier" class="result-title">{{
                r._source.title
              }}</a></span
            >

            <ul class="creator">
              <li class="date">{{ r._source.publication_date }}</li>
              &mdash;
              <li>{{ joinArray(r._source.creator, "; ") }}</li>
            </ul>
            <show-hide
              :text="r._source.description"
              :limit="descriptionLength"
            ></show-hide>
          </div>
        </div>

        <!--PERMISSIONS-->
        <div class="object-push-right">
          <div v-if="r._source.access[0].type === 'open'">
            <div class="access-box">
              <div class="access-status">
                <img class="aceess-image" src="/images/unlocked.svg" alt="Free Use" />
                <span>Free Use</span>
              </div>
              <div class="access-message">
                <span>{{ r._source.access[0].value }}</span>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="access-box">
              <div class="access-status">
                <img class="aceess-image" src="/images/locked.svg" alt="Restricted Use" />
                <span>Restricted Use</span>
              </div>
              <div class="access-message">
                <span>{{ r._source.access[0].value }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="clear-both"></div>
        <ul class="object-label">
          <li class="object-label-title">Topics:</li>
          <li
            v-for="topic in r._source.topic"
            @click.prevent="toggleFilterAction('topic.value', topic.value)"
            title="Click to toggle filtering by this term."
          >
            <button class="filter-term btn btn-light btn-sm">
              {{ topic.value }}
              <span
                v-if="isActive(topic.value, 'topic.value')"
                class="term-selected filter-icon"
              >
                <svg class="svg-icon i-checkmark">
                  <use xlink:href="#i-checkmark"></use>
                </svg>
                <svg class="svg-icon i-close">
                  <use xlink:href="#i-close"></use>
                </svg>
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useFacets } from "lit-discovery/vue/composables/useFacets";
import { computed, toRefs, defineProps } from "vue";
import showHide from "./_show-hide.vue";

const { isActive, toggleFilterAction } = useFacets();

const props = defineProps({
  mediaTypeIconMap: Object,
  r: Object,
});

const descriptionLength = 150;

const thumbnailObject = computed(() => {
  const types = props.r._source.type;
  if (!types || types.length === 0) {
    return props.mediaTypeIconMap["__default"];
  } else if (types.length === 1) {
    const typeName = types[0].value;
    const type = typeName.toLowerCase().trim();
    if (props.mediaTypeIconMap[type]) {
      return props.mediaTypeIconMap[type];
    } else {
      let iconInfo = props.mediaTypeIconMap["__default"];
      iconInfo.label = typeName;
      return iconInfo;
    }
  } else {
    return props.mediaTypeIconMap["__multiple"];
  }
});

const joinArray = (value, delimiter) => {
  if (value && Array.isArray(value)) {
    return value.join(delimiter);
  } else {
    return value;
  }
};
</script>
